import React from "react";
import { Box } from "@mui/material";

interface HeaderProps {
  width?: number;
  height?: number;
}
const Header: React.FC<HeaderProps> = ({ width = 100, height = 100 }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
    >
      <img src="/icons/logo.svg" alt="لوگو" width={width} height={height} />
    </Box>
  );
};

export default Header;
